import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/shared";
import { SERVICES } from "@/data/content";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

export default function Services() {
  return (
    <section id="servicos" className="scroll-mt-20 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Nossos serviços"
          title={<>Soluções completas em <span className="text-gold-grad">engenharia predial</span></>}
          sub="Da recuperação de fachadas à consultoria para síndicos: uma equipe, todas as frentes técnicas da sua edificação."
        />
        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {SERVICES.map((service, i) => (
            <Reveal key={service.title} delay={(i % 4) * 0.07}>
              <article
                data-testid={`service-card-${slug(service.title)}`}
                className="group relative flex h-full flex-col border border-white/[0.07] bg-navy-800/50 p-6 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:bg-navy-700/60 hover:shadow-[0_20px_50px_-20px_rgba(212,175,55,0.25)]"
              >
                <span className="pointer-events-none absolute right-5 top-4 font-mono text-[11px] text-slate-600 transition-colors group-hover:text-gold/60">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex h-12 w-12 items-center justify-center border border-gold/25 bg-gold/5 text-gold transition-all duration-500 group-hover:bg-gold group-hover:text-navy-950">
                  <service.icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <h3 className="mt-5 font-display text-xl font-bold uppercase leading-tight tracking-wide text-white">
                  {service.title}
                </h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-400">{service.desc}</p>
                <a
                  href="#orcamento"
                  data-testid={`service-link-${slug(service.title)}`}
                  className="mt-5 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-gold/80 transition-colors hover:text-gold"
                >
                  Saiba mais
                  <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
